module.exports = __webpack_public_path__ + "media/images/lb/593-21fb7f27a7f1827fbb92a57ef562eb87.svg";